module.exports = __webpack_public_path__ + "static/ReplaceOldOne-4b3798026a3a67fb1ed1f89f6b44a4ec.png";